module.exports = __webpack_public_path__ + "static/img/admin.e61ef58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin.png
// module id = YEsG
// module chunks = 0